import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI } from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const addressrecipientslice = createSlice({
    name: 'addressrecipient',
    initialState: {
        addressrecipient: {
            data: [],
            meta: [],
            loading: false,
            hasErrors: false,
            message: "",
            messageType: ""
        },
        importaddressrecipient: {
            loading: false,
            hasErrors: false,
            message: "",
            messageType: ""
        }
    },
    reducers: {
        getRecipientAddress: (state) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: true,
                    hasErrors: false
                }

            }
        },
        getRecipientAddressSuccess: (state, action) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    hasErrors: false,
                    loading: false
                }

            }
        },
        getRecipientAddressFailure: (state, action) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: false,
                    hasErrors: true,
                    message: action && action.payload && action.payload.data && action.payload.data.message
                }

            }
        },
        putRecipientAddress: (state) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: true,
                    hasErrors: false,
                }

            }
        },
        putRecipientAddressSuccess: (state, action) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: false,
                    hasErrors: false,
                    messageType: "success",
                    message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
                }

            }
        },
        putRecipientAddressFailure: (state, action) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: false,
                    hasErrors: true,
                    messageType: "failure",
                    message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
                }

            }
        },
        deleteRecipientAddress: (state) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: true,
                    hasErrors: false
                }

            }
        },
        deleteRecipientAddressSuccess: (state, action) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: false,
                    hasErrors: false,
                    messageType: "success",
                    message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
                }

            }
        },
        deleteRecipientAddressFailure: (state, action) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: false,
                    hasErrors: true,
                    messageType: "failure",
                    message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
                }

            }
        },
        postRecipientAddress: (state) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: true,
                    hasErrors: false,
                }

            }
        },
        postRecipientAddressSuccess: (state, action) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: false,
                    hasErrors: false,
                    messageType: "success",
                    message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
                }

            }

        },
        postRecipientAddressFailure: (state, action) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: false,
                    hasErrors: true,
                    messageType: "failure",
                    message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
                }

            }

        },
        postImportRecipientAddress: (state) => {
            return {
                ...state,
                importaddressrecipient: {
                    ...state.importaddressrecipient,
                    loading: true,
                    hasErrors: false,
                }

            }
        },
        postImportRecipientAddressSuccess: (state, action) => {
            return {
                ...state,
                importaddressrecipient: {
                    ...state.importaddressrecipient,
                    loading: false,
                    hasErrors: false,
                    messageType: "success",
                    message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
                }

            }

        },
        postImportRecipientAddressFailure: (state, action) => {
            return {
                ...state,
                importaddressrecipient: {
                    ...state.importaddressrecipient,
                    loading: false,
                    hasErrors: true,
                    messageType: "failure",
                    message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
                }

            }

        },
        resetRecipientAddress: (state) => {
            return {
                ...state,
                addressrecipient: {
                    ...state.addressrecipient,
                    loading: false,
                    hasError: false,
                    message: "",
                }

            }
        },
        resetImportRecipientAddress: (state) => {
            return {
                ...state,
                importaddressrecipient: {
                    ...state.importaddressrecipient,
                    loading: false,
                    hasError: false,
                    message: "",
                }

            }
        }
    }
})

export const { getRecipientAddress, getRecipientAddressSuccess, getRecipientAddressFailure,
    putRecipientAddress, putRecipientAddressSuccess, putRecipientAddressFailure,
    deleteRecipientAddress, deleteRecipientAddressSuccess, deleteRecipientAddressFailure,
    postRecipientAddress, postRecipientAddressSuccess, postRecipientAddressFailure,
    postImportRecipientAddress, postImportRecipientAddressSuccess, postImportRecipientAddressFailure,
    resetRecipientAddress, resetImportRecipientAddress } = addressrecipientslice.actions;

export const fetchRecipientAddress = meta => dispatch => {
    dispatch(getRecipientAddress());
    try {
        const qs = Object.keys(meta)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
            .join('&');
        LABELGENAPI
            .get('/settings/address-book-recipient?' + qs)
            .then(function (response) {
                dispatch(getRecipientAddressSuccess(response));
            })
            .catch(function (error) {
                dispatch(getRecipientAddressFailure(error.response));
            });
    } catch (error) {
        dispatch(getRecipientAddressFailure());
    }
};

export const storeRecipientAddress = (userid,data) => dispatch => {
    dispatch(postRecipientAddress());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.post('/settings/address-book-recipient', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(postRecipientAddressSuccess(response));
                dispatch(fetchRecipientAddress({}));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'RECIPIENT_ADDRESS_CREATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(postRecipientAddressFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'RECIPIENT_ADDRESS_CREATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                }); 
            })
    }
    catch (error) {
        dispatch(postRecipientAddressFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'RECIPIENT_ADDRESS_CREATE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        }); 
    }
}

export const updateRecipientAddress = (userid, id, data) => dispatch => {
    dispatch(putRecipientAddress());
    const logRef = crypto.randomUUID();

    try {
        LABELGENAPI.patch('/settings/address-book-recipient/' + id, data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(putRecipientAddressSuccess(response));
                dispatch(fetchRecipientAddress({}));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'RECIPIENT_ADDRESS_UPDATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(putRecipientAddressFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'RECIPIENT_ADDRESS_UPDATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                }); 
            })
    }
    catch (error) {
        dispatch(putRecipientAddressFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'RECIPIENT_ADDRESS_UPDATE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        }); 
    }

}

export const destoryRecipientAddress = (userid,id) => dispatch => {
    dispatch(deleteRecipientAddress());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI
            .delete("/settings/address-book-recipient/" + id, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(deleteRecipientAddressSuccess(response));
                dispatch(fetchRecipientAddress({}));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'RECIPIENT_ADDRESS_DELETE',
                    action: 'SUCCESS',
                    request_data: JSON.stringify(id),
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            })
            .catch(function (error) {
                dispatch(deleteRecipientAddressFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'RECIPIENT_ADDRESS_DELETE',
                    action: 'FAILURE',
                    request_data: JSON.stringify(id),
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                }); 
            });
    } catch (error) {
        dispatch(deleteRecipientAddressFailure(error));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'RECIPIENT_ADDRESS_DELETE',
            action: 'FAILURE',
            request_data: JSON.stringify(id),
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
};

export const importRecipientAddress = (userid,data) => dispatch => {
    dispatch(postImportRecipientAddress());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.post('/settings/import-recipient-address-book', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(postImportRecipientAddressSuccess(response));
                dispatch(fetchRecipientAddress({}));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'RECIPIENT_ADDRESS_IMPORT',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(postImportRecipientAddressFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'RECIPIENT_ADDRESS_IMPORT',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(postImportRecipientAddressFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'RECIPIENT_ADDRESS_IMPORT',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}

export const resetRecipientAddressState = data => dispatch => {
    dispatch(resetRecipientAddress());
}

export const resetImportRecipientAddressState = data => dispatch => {
    dispatch(resetImportRecipientAddress());
}


export default addressrecipientslice.reducer;
